export default "__VITE_ASSET__371041e1__"